import { Scope } from '@/types';

const renderScopeNumber = (v: Scope) =>
  ({
    scope1: 1,
    scope2: 2,
    scope3: 3,
  })[v];

const renderScope = (v: Scope) => `Scope ${renderScopeNumber(v)}`;

export { renderScope, renderScopeNumber };
